import { useEffect, useState } from 'react';
import { UAParser } from 'ua-parser-js';
const useDevice = () => {
  const [deviceInfo, setDeviceInfo] = useState();
  useEffect(() => setDeviceInfo(new UAParser().getResult()), []);
  return deviceInfo;
};
export default useDevice;